import { IUserData } from "../redux/types";

export type PermissionRequirement = string | string[] | undefined;

const toPermissionKeys = (permission: PermissionRequirement): string[] => {
  if (!permission) return [];
  return Array.isArray(permission) ? permission : [permission];
};

const hasPermissionKey = (
  permissions: Record<string, boolean> | undefined,
  key: string
) => {
  if (!permissions) return true;

  const value =
    permissions[key] ??
    permissions[key.toLowerCase()] ??
    permissions[key.toUpperCase()];

  // Product rule: only explicit `false` should block.
  // Missing permission key is treated as allowed.
  return value !== false;
};

export const canAccess = (
  user: IUserData | null | undefined,
  permission?: PermissionRequirement
) => {
  if (!permission) return true;
  if (!user) return false;

  // Main admin has full access by product rule.
  if (!user.is_sub_account) return true;

  const keys = toPermissionKeys(permission);
  // For grouped requirements, deny only when every key is explicitly false.
  return keys.some((key) => hasPermissionKey(user.permissions, key));
};
